'use strict';
import {$rootScopeExtensions} from './$rootScopeExtensions';

const angular = require('angular');


module.exports = angular
  .module('app.core-utilities.angular-rx-attrs', [])
  .config(require('./FirebaseObjectToObservable.js'))
  .config($rootScopeExtensions)
  .service('$attrsToObservable', require('./$attrsToObservable.js'))
;



// WEBPACK FOOTER //
// ./src/js/core-utilities/angular-rx-attrs/index.js